import port1 from '../img/portImages/asc.jpg';
import port2 from '../img/portImages/lux.jpg';
import port3 from '../img/portImages/jungle.jpg';
import port4 from '../img/portImages/scheduler.jpg';
import port5 from '../img/portImages/tweeter.jpg';
import port6 from '../img/portImages/tinyapp.jpg';

const portfolios = [
    {
        id: 1,
        category: 'ReactJS',
        link: 'https://github.com/chriskang24/advanced-movie-search',
        icon: 'View',
        image: port1,
        title: 'ASC Media Search'
    },
    {
        id: 2,
        category: 'JavaScript',
        link: 'https://github.com/chriskang24/Lux-Restaurant-App',
        icon: 'View',
        image: port2,
        title: 'Lux Restaurant App'
    },
    {
        id: 3,
        category: 'Ruby',
        link: 'https://github.com/chriskang24/jungle-rails',
        icon: 'View',
        image: port3,
        title: 'Jungle Project - Ruby on Rails'
    },
    {
        id: 4,
        category: 'ReactJS',
        link: 'https://github.com/chriskang24/scheduler',
        icon: 'View',
        image: port4,
        title: 'Interview Scheduler'
    },
    {
        id: 5,
        category: 'jQuery / AJAX',
        link: 'https://github.com/chriskang24/tweeter',
        icon: 'View',
        image: port5,
        title: 'Tweeter App'
    },
    {
        id: 6,
        category: 'NodeJS / Express',
        link: 'https://github.com/chriskang24/tinyapp',
        icon: 'View',
        image: port6,
        title: 'TinyApp'
    },
]

export default portfolios;